// =============================================================================
// Child theme entry — client-specific JS
// =============================================================================

document.addEventListener("DOMContentLoaded", () => {
	console.log("[ai-zippy-child] theme initialized");

	// 1. Highlight active menu item based on current URL path
	const highlightActiveMenu = () => {
		const currentPath = window.location.pathname.replace(/\/$/, "") || "/";
		const navLinks = document.querySelectorAll(".persol-nav-menu .wp-block-navigation-item__content");

		navLinks.forEach((link) => {
			try {
				const linkUrl = new URL(link.href, window.location.origin);
				const linkPath = linkUrl.pathname.replace(/\/$/, "") || "/";

				const isMatch = linkPath === currentPath || (linkPath !== "/" && currentPath.startsWith(linkPath));

				if (isMatch) {
					link.classList.add("is-active");
					const parentLi = link.closest(".wp-block-navigation-item");
					if (parentLi) {
						parentLi.classList.add("is-active");
						parentLi.classList.add("current-menu-item");
					}
					link.setAttribute("aria-current", "page");
				} else {
					link.classList.remove("is-active");
					const parentLi = link.closest(".wp-block-navigation-item");
					if (parentLi) {
						parentLi.classList.remove("is-active");
						parentLi.classList.remove("current-menu-item");
					}
					link.removeAttribute("aria-current");
				}
			} catch (e) {
				// Ignore URL parsing errors
			}
		});
	};

	highlightActiveMenu();

	// 2. Handle hash scroll on initial page load (e.g. /services/#rpo)
	const scrollToHash = () => {
		const hash = window.location.hash;
		if (hash) {
			const target = document.querySelector(hash);
			if (target) {
				setTimeout(() => {
					target.scrollIntoView({ behavior: "smooth", block: "start" });
				}, 150);
			}
		}
	};

	if (window.location.hash) {
		scrollToHash();
	}

	// 3. Handle in-page smooth anchor clicks
	document.addEventListener("click", (e) => {
		const anchor = e.target.closest('a[href*="#"]');
		if (!anchor) return;

		const url = new URL(anchor.href, window.location.origin);
		if (url.pathname === window.location.pathname && url.hash) {
			const targetEl = document.querySelector(url.hash);
			if (targetEl) {
				e.preventDefault();
				targetEl.scrollIntoView({ behavior: "smooth", block: "start" });
				window.history.pushState(null, "", url.hash);
			}
		}
	});
});
